import React, { useState } from "react";
import StudentGuidanceTable from "../../containers/StudentGuidance/StudentGuidanceTable";
import StudentGuidanceButton from "../../containers/StudentGuidance/StudentGuidanceButton";

function StudentGuidance(props) {
  const list = window.location.href.split("/");
  const lastValueList = list[list.length - 1].split("=");
  const selectedProfileId = lastValueList.length > 1 ? lastValueList[lastValueList.length - 1] : null;

  const [updating, setUpdating] = useState(null);

  return (
    <div style={{ padding: 8, minHeight: "calc(100vh - 178px)", position: "relative" }}>
      <StudentGuidanceButton
        type={props?.other ? "other" : props?.adminTab ? "all" : "self"}
        selectedProfileId={selectedProfileId}
        handleReload={props?.handleReload}
        setUpdating={setUpdating}
      />
      <StudentGuidanceTable
        type={props?.other ? "other" : props?.adminTab ? "all" : "self"}
        selectedProfileId={selectedProfileId}
        updating={updating}
        setUpdating={setUpdating}
        handleReload={props?.handleReload}
      />
    </div>
  );
}

export default StudentGuidance;

